module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(_vm.up) ? _c('div', {
    staticClass: "del-block m-t-5"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "copy-block m-t-5"
  }, [_c('router-link', {
    attrs: {
      "to": '/copyLimiScheduleItem/' + _vm.$route.params.setting_id + '?brand_id=' + _vm.$route.query.brand_id + '&store_id=' + _vm.$route.query.store_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("複製門市限時限量設定")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', {
    staticStyle: {
      "margin-bottom": "3em"
    }
  }, [_vm._v("\n              基本設定\n            ")]), _vm._v(" "), _c('div', [_vm._m(1), _vm._v(" "), (_vm.brandBrief.length > 1 || _vm.up) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), (!_vm.up) ? _c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "==品牌==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value",
      "disable": true
    },
    on: {
      "input": function($event) {
        return _vm.routerEvent('brand')
      }
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.brandSelect.label) + "\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), (!_vm.up) ? _c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    on: {
      "input": function($event) {
        return _vm.routerEvent('store')
      }
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.up) ? _c('div', {
    staticClass: "form-control form-info text-left"
  }, [_vm._v("\n                  " + _vm._s(_vm.storeSelect.label) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定名稱\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "16"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_vm._v("\n                  設定描述\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "備註用，不會顯示在菜單",
      "type": "text",
      "maxlength": "200"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h3', {
    staticStyle: {
      "margin-top": "2em",
      "margin-bottom": "1em"
    }
  }, [_vm._v("\n                指定區間設定\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addSectionSetting
    }
  }, [_vm._v("新增指定區間設定")])]), _vm._v(" "), _c('div', {
    staticClass: "box-table",
    staticStyle: {
      "height": "400px",
      "min-height": "300px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0  position-relative",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-striped dataTable",
    class: _vm.show_section_overlap ? 'table-borderless' : 'table-bordered'
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.rule_section_list), function(section, sIndex) {
    return _c('tr', {
      key: sIndex + ' week',
      class: section.show_overlap ? 'overlap' : ''
    }, [_c('td', {
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', {}, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.delivery_type),
        expression: "section.delivery_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(section, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.storedeliveryInfo), function(main) {
      return _c('option', {
        domProps: {
          "value": main.value
        }
      }, [_vm._v("\n                                  " + _vm._s(main.label) + "\n                                ")])
    })], 2)])]), _vm._v(" "), _c('td', {
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center"
      }
    }, [_c('div', [_c('date-time-picker', {
      attrs: {
        "placeholder": "YYYMM-DD",
        "date": section.sectionTime.start,
        "option": _vm.dateoption,
        "limit": section.startLimit
      },
      on: {
        "change": function($event) {
          return _vm.changeDate($event, 'start', sIndex)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "4px",
        "margin-right": "4px",
        "align-self": "center"
      }
    }, [_vm._v("\n                                -\n                              ")]), _vm._v(" "), _c('div', [_c('date-time-picker', {
      attrs: {
        "placeholder": "YYYMM-DD",
        "date": section.sectionTime.end,
        "option": _vm.dateoption,
        "limit": section.endLimit
      },
      on: {
        "change": function($event) {
          return _vm.changeDate($event, 'end', sIndex)
        }
      }
    })], 1)])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('vue-timepicker', {
      attrs: {
        "hide-disabled-items": "",
        "manual-input": "",
        "placeholder": "hh:mm",
        "minute-interval": 30,
        "input-class": "form-control"
      },
      model: {
        value: (section.rule_start_time),
        callback: function($$v) {
          _vm.$set(section, "rule_start_time", $$v)
        },
        expression: "section.rule_start_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('vue-timepicker', {
      attrs: {
        "hide-disabled-items": "",
        "manual-input": "",
        "placeholder": "hh:mm",
        "minute-range": [29, 59],
        "input-class": "form-control"
      },
      model: {
        value: (section.rule_end_time),
        callback: function($$v) {
          _vm.$set(section, "rule_end_time", $$v)
        },
        expression: "section.rule_end_time"
      }
    })], 1), _vm._v(" "), _c('td', {
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.src_type),
        expression: "section.src_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(section, "src_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("訂單")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("份數")])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.amount),
        expression: "section.amount"
      }],
      staticStyle: {
        "max-width": "86px",
        "height": "34px",
        "border": "1px solid #d2d6de",
        "border-radius": "0px 3px 3px 0px",
        "padding-left": "4px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (section.amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(section, "amount", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "vertical-align": "middle",
        "min-width": "100px"
      }
    }, [_c('div', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.is_enabled),
        expression: "section.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(section.is_enabled, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(section, "is_enabled", "1")
        }
      }
    }), _vm._v("\n                                  開啟\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block",
      staticStyle: {
        "margin-top": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (section.is_enabled),
        expression: "section.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(section.is_enabled, "0")
      },
      on: {
        "change": function($event) {
          return _vm.$set(section, "is_enabled", "0")
        }
      }
    }), _vm._v("\n                                  關閉\n                                ")])])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      style: (_vm.show_section_overlap ? 'vertical-align: middle' : '')
    }, [_c('div', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.rule_section_list, sIndex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])])])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-bottom": "1em",
      "margin-top": "2em"
    }
  }, [_vm._v("\n              週期設定\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addWeekSetting
    }
  }, [_vm._v("新增週期設定")])]), _vm._v(" "), _c('div', {
    staticClass: "box-table",
    staticStyle: {
      "height": "500px",
      "min-height": "300px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0 position-relative",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('table', {
    staticClass: "table table-striped dataTable",
    class: _vm.show_section_overlap ? 'table-borderless' : 'table-bordered'
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.rule_week_list), function(item, index) {
    return _c('tr', {
      key: item.id,
      class: {
        'overlap': item.show_overlap
      }
    }, [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.delivery_type),
        expression: "item.delivery_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "delivery_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "0"
      }
    }, [_vm._v("不限")]), _vm._v(" "), _vm._l((_vm.storedeliveryInfo), function(main) {
      return _c('option', {
        domProps: {
          "value": main.value
        }
      }, [_vm._v("\n                              " + _vm._s(main.label) + "\n                            ")])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.rule_day),
        expression: "item.rule_day"
      }],
      staticClass: "form-control min-w p-0",
      style: (item.rule_day === '' ? 'color: rgb(149,149,149)' : ''),
      attrs: {
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "rule_day", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": "",
        "selected": ""
      }
    }, [_vm._v("星期")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("週日")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("週一")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("週二")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("週三")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "5"
      }
    }, [_vm._v("週四")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "6"
      }
    }, [_vm._v("週五")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "7"
      }
    }, [_vm._v("週六")])])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.rule_start_time),
        expression: "item.rule_start_time"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (item.rule_start_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "rule_start_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.rule_end_time),
        expression: "item.rule_end_time"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (item.rule_end_time)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "rule_end_time", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.src_type),
        expression: "item.src_type"
      }],
      staticClass: "form-control min-w p-0",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "src_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("訂單")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("份數")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.amount),
        expression: "item.amount"
      }],
      staticStyle: {
        "max-width": "86px",
        "height": "34px",
        "border": "1px solid #d2d6de",
        "border-radius": "0px 3px 3px 0px",
        "padding-left": "4px"
      },
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "amount", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "vertical-align": "middle",
        "min-width": "100px"
      }
    }, [_c('div', {
      staticClass: "text-left"
    }, [_c('div', {
      staticClass: "radio inline-block"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "1"
      },
      domProps: {
        "checked": _vm._q(item.is_enabled, "1")
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", "1")
        }
      }
    }), _vm._v(" 開啟")])]), _vm._v(" "), _c('div', {
      staticClass: "radio inline-block",
      staticStyle: {
        "margin-top": "0px"
      }
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.is_enabled),
        expression: "item.is_enabled"
      }],
      attrs: {
        "type": "radio",
        "value": "0"
      },
      domProps: {
        "checked": _vm._q(item.is_enabled, "0")
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "is_enabled", "0")
        }
      }
    }), _vm._v(" 關閉")])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.removeListItem(_vm.rule_week_list, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-fail text-black",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n            返回\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    domProps: {
      "textContent": _vm._s(_vm.checkSettingText)
    },
    on: {
      "click": function($event) {
        return _vm.checkSetting()
      }
    }
  })])])])]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('m-modal', {
    class: [{
      'in show': _vm.checkedFormModal
    }],
    attrs: {
      "option": _vm.checkedFormModalOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left m-b-15"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', [_vm._v("若限量條件重複，會以滿足條件的最小值為主。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品牌\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    staticStyle: {
      "min-width": "138px",
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("門市\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary position-sticky"
  }, [_c('tr', [_c('td', [_vm._v("取貨方式")]), _vm._v(" "), _c('td', [_vm._v("指定區間")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("限量單位")]), _vm._v(" "), _c('td', [_vm._v("數量上限")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-primary position-sticky"
  }, [_c('tr', [_c('td', [_vm._v("取貨方式")]), _vm._v(" "), _c('td', [_vm._v("指定區間")]), _vm._v(" "), _c('td', [_vm._v("開始時間")]), _vm._v(" "), _c('td', [_vm._v("結束時間")]), _vm._v(" "), _c('td', [_vm._v("限量單位")]), _vm._v(" "), _c('td', [_vm._v("數量上限")]), _vm._v(" "), _c('td', [_vm._v("開啟狀態")]), _vm._v(" "), _c('td', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59342c1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/LimScheduleProdTemp.vue
// module id = 2435
// module chunks = 1